import React, { useState } from 'react';

const Menu = ({ topics }) => {
  const [hovered, setHovered] = useState(null);

  return (
    <>
      <style>{`
        .scrollable-menu::-webkit-scrollbar {
          height: 8px;
        }
        .scrollable-menu::-webkit-scrollbar-track {
          background: #0151a2;
        }
        .scrollable-menu::-webkit-scrollbar-thumb {
          background: #e6f4f8;
          border-radius: 4px;
        }
        .scrollable-menu::-webkit-scrollbar-thumb:hover {
          background: #fff;
        }
        .scrollable-menu {
          scrollbar-width: thin;
          scrollbar-color: #e6f4f8 #0151a2;
        }
      `}</style>

      <nav
        style={{
          width: '100vw',
          position: 'fixed',
          top: '8vh',
          left: '50%',
          transform: 'translateX(-50%)',
          background: '#02396d', // FONDO AZUL OSCURO
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
          padding: "0.5rem 0",
        }}
      >
        <div
          className="scrollable-menu"
          style={{
            display: 'flex',
            flexWrap: 'nowrap',
            gap: '0.5rem',
            overflowX: 'auto',
            overflowY: 'hidden',
            padding: '0.5rem 1rem',
            width: '97%',
            whiteSpace: 'nowrap',
          }}
        >
          {topics.map((topic) => (
            <a
              key={topic.id}
              href={`#topic-${topic.id}`}
              onClick={e => {
                e.preventDefault();
                setTimeout(() => {
                  const element = document.getElementById(`topic-${topic.id}`);
                  if (element) {
                    const headerOffset = 100;
                    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                    const offsetPosition = elementPosition - headerOffset;
                    window.scrollTo({ top: offsetPosition, behavior: "smooth" });
                  }
                }, 50);
              }}
              onMouseEnter={() => setHovered(topic.id)}
              onMouseLeave={() => setHovered(null)}
              title={topic.title}
              style={{
                flex: "0 0 auto",
                minWidth: "140px",
                maxWidth: "220px",
                padding: "0.5rem",
                height: "60px",
                background: hovered === topic.id ? "#0151a2" : "transparent", // hover azul intermedio
                color: "#fff", // texto blanco SIEMPRE
                textAlign: "center",
                textDecoration: "none",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "16px",
                transition: "all 0.25s cubic-bezier(.4,0,.2,1)",
                fontWeight: "600",
                boxShadow: hovered === topic.id ? "0 2px 8px #02396d80" : "",
                border: hovered === topic.id ? "2px solid #e6f4f8" : "2px solid transparent",
                letterSpacing: "0.02em"
              }}
            >
              <span style={{
                fontSize: "1rem",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "102%",
                fontWeight: "600",
              }}>
                {topic.title}
              </span>
            </a>
          ))}
        </div>
      </nav>
    </>
  );
};

export default Menu;
